// import React, { useEffect, useState } from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   IconButton,
//   Chip,
//   CircularProgress,
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";

// import {claimRefundApi, initiateServiceTransactionStatus} from '../../../src/api/transactionApi'

// const TransactionStatusCheckModel = ({
//   open,
//   onClose,
//   txn,
//   slug,
// }) => {
//   const [loading, setLoading] = useState(false);
//   const [data, setData] = useState(null);

//   useEffect(() => {
//     if (!open || !txn) return;

//     const fetchStatus = async () => {
//       try {
//         setLoading(true);
//         setData(null);
        
//         const payload = {
//             referenceid: txn.requestId,
//             slug,
//         }
//         // console.log('get the paylod',payload)
//         const res = await initiateServiceTransactionStatus(payload);

//         if (res?.success) {
//           setData(res.data);
//         }
//       } catch (err) {
//         console.error("Status fetch error:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchStatus();
//   }, [open, txn, slug]);



// const handleRefund = async () => {
//   try {
//     setLoading(true);

//     const payload = {
//       referenceid: txn.requestId,
//       ackno: data?.paysprintResponse?.ackno
//     };

//     const res = await claimRefundApi(payload);

//     if (res.success) {
//       alert("Refund claimed successfully");
//       onClose();
//     }
//   } catch (err) {
//     alert(err.message || "Refund failed");
//   } finally {
//     setLoading(false);
//   }
// };



//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
//       <DialogTitle className="flex justify-between items-center">
//         Transaction Status
//         <IconButton onClick={onClose}>
//           <CloseIcon />
//         </IconButton>
//       </DialogTitle>

//       <DialogContent dividers>
//         {loading ? (
//           <div className="flex justify-center py-10">
//             <CircularProgress size={28} />
//           </div>
//         ) : !data ? (
//           <p className="text-center text-sm text-gray-500">
//             No data available
//           </p>
//         ) : (
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">

//             {/* LEFT */}
//             <div className="space-y-2">
//               <p><b>Txn ID:</b> {txn.txnId}</p>
//               <p><b>Service:</b> {slug}</p>
//               <p><b>Amount:</b> ₹{txn.amount}</p>

//               <Chip
//                 label={txn.status}
//                 color={
//                   txn.status === "SUCCESS"
//                     ? "success"
//                     : txn.status === "FAILED"
//                     ? "error"
//                     : "warning"
//                 }
//                 size="small"
//               />

//               {/* {txn.status === "FAILED" && !txn.isRefunded && ( */}
//   <button
//     onClick={handleRefund}
//     className="mt-3 px-4 py-1 bg-red-600 text-white text-xs rounded"
//   >
//     Claim Refund
//   </button>
// {/* )} */}

//             </div>

//             {/* RIGHT */}
//             <div>
//               <p className="font-semibold mb-1">Paysprint Response</p>
//               <div className="bg-gray-100 rounded p-2 text-xs max-h-[260px] overflow-auto">
//                 <pre>{JSON.stringify(data.paysprintResponse, null, 2)}</pre>
//               </div>
//             </div>

//           </div>
//         )}
//       </DialogContent>
//     </Dialog>
//   );
// };

// export default TransactionStatusCheckModel;



import React, { useEffect, useState, useMemo } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Chip,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import {
  claimRefundApi,
  claimRefundApiFinal,
  initiateServiceTransactionStatus,
} from "../../../src/api/transactionApi";
import { formatAmount } from "../../utils/formatAmount";
import { useNotify } from "../../context/NotifyContext";

const TransactionStatusCheckModel = ({ open, onClose, txn, slug }) => {
  const { notify } = useNotify();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [showOtpBox, setShowOtpBox] = useState(false);
  const [otp, setOtp] = useState("");

  /* =========================
     NORMALIZATION (CRITICAL)
     ========================= */
  const normalizedTxnStatus = useMemo(() => {
    if (!txn?.transactionStatus) return "UNKNOWN";
    if (txn.transactionStatus === "FAIELD") return "FAILED"; // backend typo fix
    return txn.transactionStatus;
  }, [txn]);

  const normalizedRefundStatus = useMemo(() => {
    return (
      txn?.refundStatus ||
      txn?.isrefundStatus || // backend mismatch fix
      "NOT_APPLICABLE"
    );
  }, [txn]);

  /* =========================
     STATUS CHECK API
     ========================= */
  useEffect(() => {
    if (!open || !txn) return;

    const fetchStatus = async () => {
      try {
        setLoading(true);
        setData(null);

        const payload = {
          referenceid: txn.txnId,
          slug,
        };

        const res = await initiateServiceTransactionStatus(payload);
        if (res?.success) setData(res.data);
      } catch (err) {
        console.error("Status fetch error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchStatus();
  }, [open, txn, slug]);

  /* =========================
     HELPERS
     ========================= */
  const getTxnColor = (status) => {
    if (status === "SUCCESS") return "success";
    if (status === "FAILED") return "error";
    if (status === "PENDING") return "warning";
    return "default";
  };

  /* =========================
     REFUND ELIGIBILITY (FINAL)
     ========================= */
  const isRefundEligible =
    normalizedTxnStatus === "FAILED" &&
    normalizedRefundStatus === "ELIGIBLE" &&
    txn?.disputeStatus === "NONE";

  /* =========================
     SEND OTP
     ========================= */
  const handleSendOtp = async () => {
    try {
      setLoading(true);

      const payload = {
        referenceid: txn.txnId,
        ackno: data?.paysprintResponse?.ackno,
      };

      const res = await claimRefundApi(payload);

      if (res?.success) {
        setShowOtpBox(true);
        notify(res?.message || "OTP sent to registered mobile number", "success");
      }
      else {
        notify(res?.message || "Failed to send OTP", "error")
      }
    } catch (err) {
      notify(err?.message || "Failed to send OTP", "error");
    } finally {
      setLoading(false);
    }
  };

  /* =========================
     FINAL REFUND WITH OTP
     ========================= */
  const handleFinalRefund = async () => {
    if (!otp || otp.length !== 6) {
      return alert("Enter valid 6 digit OTP");
    }

    try {
      setLoading(true);

      const payload = {
        referenceid: txn.txnId,
        ackno: data?.paysprintResponse?.ackno,
        otp,
      };

      const res = await claimRefundApiFinal(payload);

      if (res?.success) {
        alert("Refund processed successfully");
        onClose();
      }
    } catch (err) {
      alert(err?.message || "Refund failed");
    } finally {
      setLoading(false);
    }
  };

  /* =========================
     UI
     ========================= */
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle className="flex justify-between items-center">
        Transaction Status
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {loading ? (
          <div className="flex justify-center py-10">
            <CircularProgress size={28} />
          </div>
        ) : !data ? (
          <p className="text-center text-sm text-gray-500">
            No data available
          </p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
         {/* LEFT */}
<div className="space-y-4">

  {/* BASIC INFO */}
  <div className="space-y-1 text-sm">
    <p>
      <span className="font-semibold">Request ID:</span>{" "}
      <span className="">{txn.txnId}</span>
    </p>

    <p>
      <span className="font-semibold">Service:</span>{" "}
      <span className="uppercase ">{slug}</span>
    </p>

    <p>
      <span className="font-semibold">Amount:</span>{" "}
      <span className="">₹{formatAmount(txn.amount)}</span>
    </p>
  </div>

  {/* STATUS & ACTION */}
  <div className="flex flex-col sm:flex-row sm:items-center gap-3">

    {/* STATUS CHIP */}
    <Chip
      label={normalizedTxnStatus}
      color={getTxnColor(normalizedTxnStatus)}
      size="small"
      className="!px-4 !py-1.5 !rounded-sm w-fit"
    />

    {/* CLAIM REFUND BUTTON */}
    {isRefundEligible && !showOtpBox && (
      <button
        onClick={handleSendOtp}
        disabled={loading}
        className="
          px-4 py-1.5
          text-xs font-semibold
          bg-red-600 text-white
          rounded-sm
          hover:bg-red-700
          disabled:opacity-60
          transition
          w-fit
        "
      >
        Claim Refund
      </button>
    )}
  </div>

  {/* OTP SECTION */}
  {showOtpBox && (
    <div className="mt-2 p-3 border rounded-lg  space-y-2">

      <p className="text-xs text-gray-600">
        Enter OTP sent to your registered mobile number
      </p>

      <input
        type="tel"
        inputMode="numeric"
        pattern="[0-9]*"
        maxLength={6}
        value={otp}
        onChange={(e) => setOtp(e.target.value)}
        placeholder="Enter 6 digit OTP"
        className="w-full border px-3 py-2 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-green-400"
      />

      <button
        onClick={handleFinalRefund}
        disabled={loading}
        className="
          w-full sm:w-auto
          px-4 py-2
          bg-green-600 text-white
          text-xs font-semibold
          rounded-md
          hover:bg-green-700
          disabled:opacity-60
          transition
        "
      >
        Submit OTP
      </button>
    </div>
  )}
</div>


            {/* RIGHT */}
            <div>
              <p className="font-semibold mb-1">Paysprint Response</p>
              <div className="border border-gray-100 rounded p-2 text-xs max-h-[260px] overflow-auto">
                <pre>
                  {JSON.stringify(data?.paysprintResponse, null, 2)}
                </pre>
              </div>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default TransactionStatusCheckModel;
